import React from "react";
import "./Loader.css";

const Spinner = () => (
  <div className="pos-center">
    <div className="loader"></div>
  </div>
);

export default Spinner;
